import "@common/helpers/i18n";
import store from "@store";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";
import Router from "./Router";
import ThemeProvider from "./ThemeProvider";
import './assets/main.scss';
import './assets/index.css';
import { App as AppProvider } from 'antd';

export default function App() {
    return (
        <AppProvider>
            <ReduxProvider store={store}>
                <HelmetProvider>
                    <ThemeProvider>
                        <Router />
                    </ThemeProvider>
                </HelmetProvider>
            </ReduxProvider>
        </AppProvider>
    );
}
